<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <span class="txt">직원목록</span>
                <div class="com-search-input" @keypress.enter="onEventSearch">
                    <input v-model="searchStr" placeholder="이름 입력" type="text" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>
        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/employee/edit">등록</router-link>
                </div>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 320px" />
                    <col style="width: 264px" />
                    <col style="width: 300px" />
                    <col style="width: 426px" />
                    <col style="width: 227px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>직원명</button>
                        </th>
                        <th>연락처</th>
                        <th>
                            <button>권한</button>
                        </th>
                        <th>이메일</th>
                        <th>등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="staff in employeeList" :key="staff.s_id">
                        <td>
                            <router-link :to="`/madmin/employee/edit/${staff.s_id}`" class="link">
                                {{ staff.s_namee }}
                            </router-link>
                        </td>
                        <td>{{ staff.s_phone | phoneNumberFilter }}</td>
                        <td></td>
                        <td>{{ staff.s_email }}</td>
                        <td>{{ staff.s_cre_dt | timestampFilter }}</td>
                    </tr>
                    <tr v-if="employeeList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                    <!--
                <tr>
                    <td><a href="/madmin/member/edit" class="link">홍길동</a></td>
                    <td>010-9999-9999</td>
                    <td>영업팀</td>
                    <td>asjdfiop@navver.com</td>
                    <td>2019-07-07</td>
                </tr>
                --></tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'employeeList',
    props: {},
    computed: {},
    data() {
        return {
            isLoading: false,
            employeeList: [],
            searchStr: '',
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            pagingInfo: { ...pagingInfo },
        };
    },
    mounted() {
        this.onSearchList();
    },
    methods: {
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getEmployeeList();
                this.setPageParams(data);
                this.employeeList = data.items;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getEmployeeList() {
            return api.get('/admin/api/ft/staff', {
                params: {
                    searchStr: this.searchStr,
                    ...this.pagingInfo,
                },
            });
        },

        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
    },
};
</script>
<style lang="scss"></style>
